import { Subject } from '@app/shared/rx';
import { ScanningService } from '@app/shared/services';

export interface IArtificialInputWatcherOption {
  eventHandler?: (
    event: KeyboardEvent,
    skipArtificialInputCheck: boolean,
  ) => void;
  updateValueBeforeEventHandler?: boolean;
  passByKeyList?: string[];
  nativeElement?: HTMLElement;
  artificialInputThreshold?: number;
  cancelSubscription$?: Subject<void>;
  isValidScanning?: boolean;
  scanningService?: ScanningService;
}

export enum EInputEvent {
  KEYDOWN = 'keydown',
  KEYUP = 'keyup',
}
